import React, { useEffect, useState } from 'react';
import icon from '../../../../assets/recovery-convert.png';
import moment, { Moment } from 'moment';
import { numberWithCommas } from '../../../../utils/formatNumber';
import StatusView from '../../../../components/StatusView/StatusView';
import { Button } from 'flowbite-react';
import { FaShare } from 'react-icons/fa';
import client from '../../../../api/client';
import showToast from '../../../../components/CustomToast/toastHelper';
import CustomModal from '../../../../components/Modal/CustomModal';
import PayoutVerificationModal from '../PayoutVerificationModal/PayoutVerificationModal';
import html2pdf from 'html2pdf.js';
import logo from '../../../../assets/IdeospayLogo.png'

interface TransferProps {
    transaction: any;
    closeTransferDetailsModal: () => void,
    onSuccessfulVerification: () => void
}

const TransferDetails = ({ transaction, closeTransferDetailsModal, onSuccessfulVerification }: TransferProps) => {
    const [transactionDetails, setTransactionDetails] = useState<any[]>([]);
    const [openOtpModal, setOpenOtpModal] = useState<boolean>(false)
    const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

    const generatePDF = () => {
        setIsGeneratingPDF(true)
        const element = document.getElementById('pdf-content');
        const options = {
            margin: [10, 10, 10, 10], // top, right, bottom, left
            filename: `transaction-${transaction.payoutReference}.pdf`,
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        };

        html2pdf().set(options).from(element).save().then(() => {
            setIsGeneratingPDF(false);
        });
    };
    const resendOtp = async (batchId: Number) => {
        try {
            const response = await client.get(`/subsidiary/payout/resend/otp/${batchId}`);
            const message = response?.data?.message;
            showToast(message, "success");
            setOpenOtpModal(true)
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    }
    useEffect(() => {
        const initialDetails = [
            { label: 'Transaction ID', value: transaction.id },
            { label: 'Batch Id', value: transaction.batchId },
            { label: 'Payout Reference', value: transaction.payoutReference },
            { label: 'Batch Reference', value: transaction.batchReference },
            { label: 'Debit Currency', value: transaction.debitCurrency },
            { label: 'Transaction Amount', value: numberWithCommas(transaction.amount) },
            { label: 'Fee', value: numberWithCommas(transaction.fee) },
            { label: 'Account Number', value: transaction.accountNumber },
            { label: 'Recipient Name', value: transaction?.recipientName ?? 'Not Available' },
            { label: 'Receiving Bank', value: transaction.bankName },
            { label: 'Transfer Type', value: transaction.transferType },
            { label: 'Date Initiated', value: (moment.utc(transaction?.dateInitiated).local() as Moment).format('DD-MMM-YYYY hh:mm:ss a') },
            { label: 'Settlement Date', value: (moment.utc(transaction?.dateSettled).local() as Moment).format('DD-MMM-YYYY hh:mm:ss a') },
            {
                label: 'Status',
                value: <StatusView status={transaction?.status} green="Successful" red="Failed" orange="Initiated" />,
            },
        ];

        if (transaction.status === 'Awaiting Verification') {
            initialDetails.push({
                label: 'Action',
                value: <div className='underline hover:cursor-pointer' onClick={() => resendOtp(transaction.batchId)}>Click to resend Verification OTP</div>,
            });
        }

        setTransactionDetails(initialDetails);
    }, [transaction]);

    return (
        <div id='pdf-content'>
            {isGeneratingPDF && <div className='flex justify-center'>
                <img src={logo} />
            </div>}
            <div>
                <img src={icon} className="my-3" alt="icon" />
                <div className="my-3">
                    <p className="text-xl font-bold">Transaction Details</p>
                    <p className="text-sm">Kindly find your transaction details below</p>
                </div>
            </div>
            <div>
                {transactionDetails.map((detail, index) => (
                    <div key={index}>
                        <div className="flex my-4 items-center text-xs">
                            <p>{detail.label}</p>
                            <p className="font-semibold ml-auto text-right">{detail.value}</p>
                        </div>
                        <hr />
                    </div>
                ))}
            </div>

            {!isGeneratingPDF && <div className="flex justify-center my-4 print:!hidden">
                <Button className="rounded-full bg-custom-button-green" onClick={() => generatePDF()}>
                    <div className="flex items-center gap-4">
                        <FaShare />
                        <p>Share transaction details</p>
                    </div>
                </Button>
            </div>}
            <CustomModal title='Verify Payout' dismissible show={openOtpModal} icon='' onClose={() => setOpenOtpModal(false)} size='md'>
                <PayoutVerificationModal close={() => { setOpenOtpModal(false); closeTransferDetailsModal() }} batchId={transaction.batchId} onSuccessfulVerification={onSuccessfulVerification} />
            </CustomModal>
        </div>
    );
};

export default TransferDetails;
